/* eslint-disable no-console */
import SendBird from 'sendbird'

const toSimpleMessage = msg => {
  if (msg.messageType === 'admin') {
    return {
      id: msg.messageId,
      message: msg.message,
      sentAt: msg.createdAt,
      type: 'admin'
    }
  } if (msg.messageType === 'user') {
    return {
      id: msg.messageId,
      user: parseInt(msg.sender.userId, 10),
      message: msg.message,
      nickname: msg.sender.nickname,
      sentAt: msg.createdAt,
      type: 'user'
    }
  } else {
    console.log(`Unknown message type ${msg.messageType}`)
    return null
  }
}

const toSimpleMember = m => {
  return {
    id: parseInt(m.userId, 10),
    nickname: m.nickname,
  }
}

const toSimpleChannel = ch => {
  const lastMessage = ch.lastMessage && toSimpleMessage(ch.lastMessage)
  const lastVisibleMessage = (lastMessage && lastMessage.type === 'user') ? lastMessage : null

  return {
    id: ch.url,
    members: ch.members.map(toSimpleMember),
    name: ch.name,
    lastMessage: lastVisibleMessage
  }
}

const sendbirdInstance = (sb, callbacks) => {
  let activeChannel
  let messageList

  return {
    // Currently not enabled because of our current billing plan we have with SB
    searchMessages: async keywords => {
      const messageQuery = sb.createMessageSearchQuery(keywords)

      if (messageQuery.hasNext) {
        const messages = await messageQuery.next()

        console.log('SDK - onSearchMessagesLoad callback')
        callbacks.onSearchMessagesLoad(messages)
      }
    },
    getAllConversations: async () => {
      const channelListQuery = sb.GroupChannel.createMyGroupChannelListQuery()
      channelListQuery.includeEmpty = true
      channelListQuery.order = 'latest_last_message'
      channelListQuery.limit = 100

      if (channelListQuery.hasNext) {
        const groupChannels = await channelListQuery.next()
        const groupChannelsUrls = groupChannels.map(toSimpleChannel)

        console.log('SDK - onConversationsLoad callback', groupChannelsUrls)
        callbacks.onConversationsLoad(groupChannelsUrls)
      }
    },
    selectActiveConversation: async id => {
      try {
        activeChannel = await sb.GroupChannel.getChannel(id)
        messageList = activeChannel.createPreviousMessageListQuery()

        const rawMessages = await messageList.load(20, false)
        const messages = rawMessages.map(toSimpleMessage)
        const conversationMessages =
          messages
            .filter(Boolean)
            .filter(m => m.type === 'user')

        const activeConversation = { id, messages: conversationMessages }
        console.log('SDK - onActiveConversationLoad callback', id)

        callbacks.onActiveConversationLoad(activeConversation)
      } catch (error) {
        console.log('SDK - selectActiveConversation error', error)
        callbacks.onError(error, 'selectActiveConversation')
      }
    },
    sendMessage: message => {
      // Sendbird SDK doesn't like Promises - async/await on this specific call
      activeChannel.sendUserMessage(message, createdMessage => {
        console.log('SDK - onMessageSent callback', { activeChannel, createdMessage })
        callbacks.onMessageSent({ message: toSimpleMessage(createdMessage) })
      })
    },
    fetchMoreMessages: async () => {
      if (messageList.hasMore) {
        const fullMessages = await messageList.load(20, false)
        const messages = fullMessages.map(toSimpleMessage)
        console.log('SDK - onMoreMessagesLoaded callback', fullMessages)
        callbacks.onMoreMessagesLoaded({ messages })
      }
    },
    disconnect: () => {
      sb.removeAllChannelHandlers()
      sb.disconnect()
    },
  }
}

const SendbirdSDK = {
  init: (appId, userId, accessToken, callbacks) => {
    const CHANNEL_HANDLER_ID = 'channelHandler'

    console.log(`SDK - Initializing Sendbird`)

    const sb = new SendBird({ appId })

    const ch = new sb.ChannelHandler()

    ch.onMessageReceived = (channel, message) => {
      console.log('SDK - Message received: ', { channel, message })
      const payload = { channel: toSimpleChannel(channel), message: toSimpleMessage(message) }
      callbacks.onMessageReceived(payload)
    }

    sb.addChannelHandler(CHANNEL_HANDLER_ID, ch)

    return sb.connect(userId, accessToken).then(user => {
      console.log(`SDK - Connected to Sendbird "${user.nickname}"`)
      return sendbirdInstance(sb, callbacks)
    })
  },
}

export default SendbirdSDK
